import { render, staticRenderFns } from "./TenantUserCreateDetailsTab.vue?vue&type=template&id=8726396c"
import script from "./TenantUserCreateDetailsTab.vue?vue&type=script&lang=ts"
export * from "./TenantUserCreateDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports